import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'nbx-toggle',
  templateUrl: './toggle.component.html',
  styleUrls: ['./toggle.component.scss'],
})
export class ToggleComponent {
  @Input() labelPos = 'start';
  @Input() status = 'basic';
  @Input() label = ''

  check = false;
  @Output() checked = new EventEmitter()


  checkstatus() {
    if (this.check == false) {
      this.check = true;
      this.checked.emit(this.check); 
    }
    else {
      this.check = false;
      this.checked.emit(this.check); 
    }
  }
}